import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiFeedbacksReportsMonthly } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/reports/monthly/getData', async datas => {
    const { data } = await apiFeedbacksReportsMonthly(datas)
    return data
})

export const monthlySlice = createSlice({
    name: 'admin/reports/monthly',
    initialState: {
        loading: true,
        start: moment().startOf('year').locale('en').format('YYYY-MM-DD'),
        end: moment().endOf('year').locale('en').format('YYYY-MM-DD'),
        data: [],
    },
    reducers: {
        setDate: (state, { payload: { start, end } }) => {
            state.start = start
            state.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.data = []
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload
            })
    },
})

export const { setDate } = monthlySlice.actions

export default monthlySlice.reducer
